<template>
  <div id="contain">
    <Header :title = 'title'></Header>
    <div id="main" ref="box">
      <flow-information :warningdetails = "warningdetails"></flow-information>
      <div class="way">
        <p class="font">处置方式：</p>
        <div   :class="[{bottom:flag},'disposal']">{{ bg }}<img :src="require('../../assets/images/opation.png')" @click="handle">
        </div>
        <div v-show="flag"  class="opaction">
          <div class="select" v-for="(item,index) of plan " :key= item.id @click="click(index)">{{item.name}}</div>
        </div>
      </div>
      <div class="notes" v-if="active">
        <p class="font">添加备注：</p>
        <div class="addnotes"> <textarea v-model="notes" @change="remark" v-focus></textarea>
        <van-uploader v-model="fileList" multiple  :after-read="afterRead" :max-count="3"/>
        </div>
      </div>
      <div class="receiver" v-show="recipient">
        <p class="font">接收人：</p>
        <div class="people">
          <span v-for="(item,i) in recipientPeople" :key="i">{{item}}</span>
          <div class="addPeople" @click="checkPeople"><img src="../../assets/images/addPeople.png" class="addImg"> </div></div>
      </div>
      <div class="receiver" v-show="recipient">
        <p class="font">抄送人：</p>
        <div class="people">
          <span v-for="(item,e) in copyPeople" :key="e">{{item}}</span>
          <div class="addPeople"><img src="../../assets/images/addPeople.png" class="addImg"> </div></div>
      </div>
      <div class="btn"><div class="submit" @click="submits">提交</div></div>
    </div>
    <van-dialog v-model="show" title="选择人员" show-cancel-button>
      <van-checkbox-group v-model="result" direction="horizontal">
        <van-checkbox ref="checkboxes" v-for="(item, index) in list" :key="index" :name="item" @click="toggle(index)">{{item}}</van-checkbox>
        <!-- <van-checkbox name="b">李四</van-checkbox> -->
      </van-checkbox-group>
    </van-dialog>
    <Footer/>
  </div>
</template>

<script>
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer'
import FlowInformation from '../../components/FlowInformation'
import { getAlarmDetail, getHandleType, getReadState } from '../../api/earlydisposal' // getReadState
import Vue from 'vue'
import { Uploader, Toast, Dialog, Checkbox, CheckboxGroup } from 'vant'
import axios from 'axios'
Vue.use(Uploader)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
export default {
  components: {
    Header,
    FlowInformation,
    Footer
  },
  data () {
    return {
      result: [], // 选中的接收人
      list: ['张三', '李四', '王二', '王五', '赵四', '王三'],
      show: false,
      warningdetails: '', // 预警处置基本信息
      bg: '', // 处置方式选中值
      flag: '',
      active: '',
      recipient: '',
      recipientPeople: ['张三', '李四'], // 接收人
      copyPeople: ['张三', '李四'], // 抄送人
      notes: '',
      title: '预警处置',
      id: 0,
      bottom: '',
      plan: [],
      fileList: []
    }
  },
  created () {
    console.log('id', this.$route.params.id)
    // this.$wx.config({
    //   debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //   appId: 'wx6e2b7edf5ccc546f', // 必填，公众号的唯一标识
    //   timestamp: '', // 必填，生成签名的时间戳
    //   nonceStr: '', // 必填，生成签名的随机串
    //   signature: '', // 必填，签名
    //   jsApiList: ['chooseImage'] // 必填，需要使用的JS接口列表
    // })
    // async getHandleType({
    //   url: '/alarm/handle_type'
    // }).then(res => {
    //   this.plan = res.data.data
    // })
    getAlarmDetail({
      url: '/alarm/info',
      data: {
        alarm_id: this.$route.params.id
      }
    }).then(res => {
      if (res !== null) {
        console.log(res)
        this.warningdetails = res.data.data
        console.log('预警处置', res, 'res.data.data', res.data.data)
      }
    })
    this.handle_type().then(() => {
      console.log(this.plan, 'ddd')
      this.bg = this.plan[0].name
    })
  },
  mounted () {
    getReadState({
      url: '/alarm/read',
      data: {
        alarm_id: this.$route.params.id
      }
    })
  },
  methods: {
    // 提交
    submits () {
      // getReadState({
      //   url: '/alarm/read',
      //   data: {
      //     alarm_id: this.$route.params.id
      //   }
      // }).then(res => {
      //   if (res !== null) {
      //     console.log(res)
      //     console.log('预警处置', res, 'res.data.data', res.data.data)
      //   }
      // })
      console.log(1)
    },
    // 选择人员弹窗
    checkPeople () {
      this.show = true
    },
    toggle (index) {
      console.log(index)
      console.log(this.$refs.checkboxes[index].name)
      console.log(this.result)
      this.recipientPeople = this.result
    },
    async handle_type () {
      const _self = this
      const response = await getHandleType({
        url: '/alarm/handle_type'
      })
      console.log(response, 'response')
      _self.plan = response.data.data
    },
    // 回调：组件选择图片成功后的回调函数
    afterRead (file, detail) {
      // 此时可以自行将文件上传至服务器
      // 1.先判断是否是单个对象
      // 2.否则就是数组，需要遍历进行转换，再上传（当然，如果你们接口支持同时传多个到服务器，就需要对后面的逻辑进行修改）
      console.log(file)
      if (!Array.isArray(file)) {
        this.uploadImgFun(file.content)
      } else {
        for (let i = 0; i < file.length; i++) {
          if ((this.fileList.length + i) >= this.countIndex) {
            // Toast("最多上传9张图片")
            break
          } else {
            this.uploadImgFun(file[i].content)
          }
        }
      }
    },
    uploadImgFun (content) {
    // 再做一次最大张数图片的判断，避免异步偷跑
      if (this.fileList.length >= 3) {
        Toast('最多上传3张图片')
        return
      }
      // 创建表单数据格式，以表单的数据传递，对该表单进行添加参数
      const formData = new FormData()
      // formData.append("参数名1", "参数值1");
      // formData.append("参数名2", "参数值2");
      // formData.append("参数名3", "参数值3");
      formData.append('image', this.dataURLtoFileFun(content, 'file.jpg'))
      // 注意需要在调用接口的时候修改请求头为"multipart/form-data"，以表单的格式上传
      // this.$_http.post(this.$_API.TMC_POST_UPLOAD_FILE, formData, {
      //   headers: {
      //     'Content-Type': 'multipart/form-data'
      //   }
      // }).then(res => {
      //   // 上传到服务器成功的操作...
      // })
      const token = JSON.parse(sessionStorage.getItem('h5')) ? JSON.parse(sessionStorage.getItem('h5')).token : ''
      console.log(token)
      axios.post('http://ai.tehn.com.cn/envcheck2/public/upload', formData, { headers: { 'Content-Type': 'multipart/form-data', token: token } }).then(res => { console.log(res) })
        .catch(error => { console.log(error) })
      // getReadState({
      //   url: '/upload',
      //   data: {
      //     image: formData
      //   },
      //   headers: {
      //     'Content-Type': 'multipart/form-data'
      //   }
      // }).then(res => {
      //   if (res !== null) {
      //     console.log(res)
      //     console.log('预警处置', res, 'res.data.data', res.data.data)
      //   }
      // })
    },
    // bae64转文件对象
    dataURLtoFileFun (dataurl, filename) {
      // 将base64转换为文件，dataurl为base64字符串，filename为文件名（必须带后缀名，如.jpg,.png）
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    handle () {
      this.flag = !(this.flag)
      this.$nextTick(() => {
        this.$refs.box.scrollTop = this.$refs.box.scrollHeight
      })
    },
    // 添加备注输入事件
    remark () {
      console.log(this.notes)
    },
    // 处置方式点击事件
    click (index) {
      this.bg = this.plan[index].name
      this.flag = !(this.flag)
      console.log(this.bg)
    }
  },
  directives: {
    focus: {
      // 指令的定义
      inserted: function (el) {
        el.focus()
        console.log('是否触发啦')
      }
    }
  },
  watch: {
    bg (val) {
      if (val === '其他') {
        this.active = true
      } else {
        this.active = false
      }
      if (val === '上报领导') {
        this.recipient = true
        this.active = true
      } else {
        this.recipient = false
      }
    },
    fileList (old, newvalue) {
      console.log('图片', old, newvalue)
    }
  }
}

</script>

<style lang='scss' scoped>
  #contain{
    height: 100%;
    display: flex;
    flex-direction:column;
    .van-checkbox-group{
      height: 120px;
    }
    #main{
      background-color: #F0F0F0;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow: auto;
      ::-webkit-scrollbar {
          width: 0px;
      }
      .way{
        width: 3.51rem;
        margin-top: .23rem;
        .disposal{
          width: 3.51rem;
          height: 5.31vh;
          background-color: #ffff;
          padding-left: .22rem;
          display: flex;
          flex-direction: row;
          align-items: center;
          position: relative;
          box-sizing: border-box;
          box-shadow:1px 1px .03rem 0px rgba(26,26,26,0.4);
          border-radius:.04rem;
          img{
            position: absolute;
            display: block;
            right: .22rem;
            width: .18rem;
            height: .09rem;
          }
        }
         .opaction{
            width: 100%;
            position: relative;
            top: 0.2vh;
            left: 0;
            box-sizing: border-box;
            border-radius: 0.04rem;
            background-color: #ffff;
            .select{
              line-height: 5.47vh;
              padding-left: .22rem;
              margin: 0 .12rem;
              border-bottom: 1px solid rgba(26,26,26,0.4);
            }
            div{
              &:last-child{
                border-bottom: none;
              }
            }
            .bg{
              background-color: rgba(128,128,128,0.6);
            }
          }
      }
    .notes{
      width: 3.51rem;
      margin-top: .23rem;
      .addnotes{
        width: 3.51rem;
        background-color: #ffff;
        box-shadow:1px 1px .03rem 0px rgba(26,26,26,0.4);
        border-radius:.04rem;
        box-sizing: border-box;
        textarea{
          box-sizing: border-box;
          width: 100%;
          border: none;
          padding: .05rem;
          border-radius: .04rem;
          resize:none
        }
        img{
          width: .23rem;
          height: .23rem;
          vertical-align: bottom;
          margin-bottom: .05rem;
        }
      }
      }
    }
    .receiver{
      width: 3.51rem;
      margin-top: 3.81vh;
      .people{
        width: 3.51rem;
        height: 6.63vh;
        position: relative;
        background-color: #ffff;
        box-shadow:1px 1px .03rem 0px rgba(26,26,26,0.2);
        border-radius:.04rem;
        box-sizing: border-box;
        span{
          margin-right: 5px;
        }
        .addPeople{
          position: absolute;
          right: .1rem;
          top: 50%;
          margin-top: -0.1rem;
          .addImg{
            width: .2rem;
            height: .2rem;
          }
        }
      }
    }
    .btn{
        display: flex;
        justify-content: center;
        width: 100%;
        margin-top: .24rem;
        padding-bottom: .12rem;
        .submit{
          width:2.62rem;
          height:5.31vh;
          background:rgb(0,158,255);
          border-radius:.16rem;
          text-align: center;
          font-size:.12rem;
          font-family:Source Han Sans CN;
          font-weight:500;
          color:rgba(254,254,254,1);
          line-height:5.31vh;
        }
      }
    .font{
        font-size: .12rem;
        line-height:.19rem;
        font-family:Source Han Sans CN;
        font-weight:400;
        color:rgba(127,127,127,1);
        line-height:.19rem;
        padding-bottom: .02rem;
      }
  }
</style>
